export const BackgroundColorTypeHex = {
  'Alice Blue': '#f5fcff',
  Azure: '#0076ad',
  'Background Image': 'transparent',
  Black: '#0b1a21',
  'Blue 5 (Primary)': '#009de6',
  'Blue 6': '#0076ad',
  'Blue 7': '#003954',
  'Blue Video': '#00a9f7',
  'Bright Blue': '#009de6',
  'Bright Neutral': '#f6f8fa',
  'Dark Blue': '#003954',
  'Dark Gray': '#222222',
  'Light Gray': '#637984',
  'Medium Blue': '#0076ad',
  'Neutral 5 (Primary)': '#637984',
  'Neutral 6': '#354f5b',
  'Neutral 7': '#0b1a21',
  Orange: '#ff8424',
  'Orange 5 (Primary)': '#ff8424',
  'Orange 6': '#da6d17',
  'Orange 7': '#ad4c00',
  'Pro Products: Gray': '#222222',
  Prussian: '#003954',
  'Sky Blue': '#009de6',
  'Standard Blue': '#009de6',
  'Teal 5 (Primary)': '#12889d',
  'Teal 6': '#0b6270',
  'Teal 7': '#004551',
  Transparent: 'transparent',
  White: '#ffffff',
};
